
  export const CANCELREASONS_RECEIVED = "CANCELREASONS_RECEIVED";
  export const SET_CANCELREASON = "SET_CANCELREASON";
  export const CREATE_CANCELREASON = "CREATE_CANCELREASON";
  export const SET_PROPERTY_CANCELREASON = "SET_PROPERTY_CANCELREASON";
  